import React, { useEffect, useState } from "react";
import Grain from "../Grain/Grain";
import Reveal from "../Reveal/Reveal";
import { STATS } from "../../data/siteContent";
import { useInView } from "../../hooks/useInView";
import { prefersReducedMotion } from "../../utils/motion";
import "./styles.css";

const DURATION_MS = 1700;

// Conta de 0 até `target` (ease-out) quando o número aparece na tela.
const CountUp = ({ target }) => {
  const [ref, inView] = useInView({ threshold: 0.5, rootMargin: "0px" });
  const [value, setValue] = useState(0);

  useEffect(() => {
    if (!inView) return;
    if (prefersReducedMotion()) {
      setValue(target);
      return;
    }

    let frame;
    const start = performance.now();
    const step = (now) => {
      const progress = Math.min(1, (now - start) / DURATION_MS);
      setValue(Math.round(target * (1 - Math.pow(1 - progress, 3))));
      if (progress < 1) frame = requestAnimationFrame(step);
    };
    frame = requestAnimationFrame(step);
    return () => cancelAnimationFrame(frame);
  }, [inView, target]);

  return <span ref={ref}>{value.toLocaleString("pt-BR")}</span>;
};

const Numbers = () => (
  <section className="numbers dark" id="numbers">
    <div className="glow glow-a" style={{ left: "auto", right: -160, top: -180 }} />
    <div className="gridlines" />
    <Grain variant="hard" />
    <div className="container">
      <Reveal className="section-head">
        <span className="tag">Resultados</span>
        <h2 className="display">Menos burocracia já é rotina</h2>
      </Reveal>
      <div className="num-grid">
        {STATS.map((stat, i) => (
          <Reveal className="num-card" delay={i} key={stat.label}>
            <span className="tag">{stat.label}</span>
            <div className="value">
              <CountUp target={stat.value} />
              <sup>{stat.suffix}</sup>
            </div>
            <p>{stat.description}</p>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Numbers;
